import { render, staticRenderFns } from "./Godsons.vue?vue&type=template&id=01896ab7"
import script from "./Godsons.vue?vue&type=script&lang=js"
export * from "./Godsons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports